import { createSingleEntityStore } from '@recruitee/ngrx';

import { EmailTemplatesAssignedOffersList, EntityStoreKey } from '../../types';

const { actions, selectors, reducer, namespace } =
  createSingleEntityStore<EmailTemplatesAssignedOffersList>()(
    EntityStoreKey.EmailTemplatesAssignedOffers,
    {
      customActions: adapter => ({
        fetch: (
          state,
          payload: { id: number; searchParams: { q: string | null; page: number; limit: number } },
        ) => adapter.markAsPending(state),
      }),
    },
  );

export {
  actions as EmailTemplatesAssignedOffersActions,
  selectors as EmailTemplatesAssignedOffersSelectors,
  reducer as EmailTemplatesAssignedOffersReducer,
  namespace as EmailTemplatesAssignedOffersNamespace,
};
